import { Module, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioDevExt } from '@/classes/scenario/dev/ScenarioDevExt';

const getDefaultFields = () => new ScenarioDevExt();

@Module({
  namespaced: true
})
class DevModule extends VuexModule {
  get getConfig(): ScenarioExt {
    return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
  }

  get getFields(): ScenarioDevExt {
    return this.getConfig.dev ? new ScenarioDevExt(this.getConfig.dev) : getDefaultFields();
  }
}

export default DevModule;
